export enum ButtonSize {
  Default = 'md',
  ExtraSmall = 'xs',
  Compact = 'sm',
  Large = 'lg'
}
